/// <reference types="vite/client" />
// Every language's words, src/locales/<language>/<namespace>.json, read in
// at build time. English is the source: its namespaces type every key the
// app asks for, and every other language has the same keys
// (i18n.test.ts). The guide (docs.json) is read whole by docs.ts, never
// through i18next, so its `{{app-name}}` is shown as written.
import admin from "../locales/en/admin.json";
import agents from "../locales/en/agents.json";
import author from "../locales/en/author.json";
import bank from "../locales/en/bank.json";
import billing from "../locales/en/billing.json";
import candidate from "../locales/en/candidate.json";
import classes from "../locales/en/classes.json";
import common from "../locales/en/common.json";
import consoleWords from "../locales/en/console.json";
import demo from "../locales/en/demo.json";
import edition from "../locales/en/edition.json";
import errors from "../locales/en/errors.json";
import exams from "../locales/en/exams.json";
import files from "../locales/en/files.json";
import format from "../locales/en/format.json";
import home from "../locales/en/home.json";
import login from "../locales/en/login.json";
import machines from "../locales/en/machines.json";
import recordings from "../locales/en/recordings.json";
import room from "../locales/en/room.json";
import session from "../locales/en/session.json";
import shares from "../locales/en/shares.json";
import shell from "../locales/en/shell.json";
import templates from "../locales/en/templates.json";
import workbench from "../locales/en/workbench.json";

/** The English namespaces: what a key is checked against. */
const en = { admin, agents, author, bank, billing, candidate, classes, common, console: consoleWords, demo, edition, errors, exams, files, format, home, login, machines, recordings, room, session, shares, shell, templates, workbench };
export type Resources = typeof en;
export const namespaces = Object.keys(en) as (keyof Resources)[];

const modules = import.meta.glob<{ default: unknown }>("../locales/*/*.json", { eager: true });

/** Every language's files, as language → namespace → its JSON. */
export const bundles: Record<string, Record<string, unknown>> = {};
for (const [path, m] of Object.entries(modules)) {
  const [, lang, ns] = /locales\/([^/]+)\/([^/]+)\.json$/.exec(path)!;
  (bundles[lang!] ??= {})[ns!] = m.default;
}
